module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', {
    staticClass: "bg-gray-100 min-h-screen flex flex-col"
  }, [_c('div', {
    staticClass: "bg-gradient-to-b from-secondary to-primary"
  }, [_c('div', {
    staticClass: "p-2 mb-5"
  }, [_c('app-header', {
    staticClass: "text-white",
    attrs: {
      "icon": "tools"
    }
  }, [_c('div', {
    staticClass: "flex items-center justify-between"
  }, [_c('h1', {
    staticClass: "text-2xl font-semibold tracking-wide"
  }, [_vm._v(_vm._s(_vm.fibsdd.numero))])])]), _vm._v(" "), _c('action-bar', {
    staticClass: "!p-0 mb-2",
    attrs: {
      "back": {
        name: 'liste-fibsdd'
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 shadow-xl pb-28",
    attrs: {
      "id": "container-fi"
    }
  }, [_c('div', {
    staticClass: "shadow-2xl rounded-lg mb-30 bg-white p-4"
  }, [_c('nav-fibsdd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeSection !== 'start'),
      expression: "activeSection !== 'start'"
    }],
    attrs: {
      "page": _vm.activeSection
    },
    on: {
      "changeSection": _vm.navigateTo
    }
  }), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeSection === 'start'),
      expression: "activeSection === 'start'"
    }],
    attrs: {
      "id": "start"
    }
  }, [_c('small-recap', {
    attrs: {
      "code": _vm.fibsdd.numero,
      "ot": _vm.fibsdd.ordre_travail,
      "detenteur": _vm.detenteur,
      "installation": _vm.installation,
      "gotFluide": _vm.isFluide,
      "isFibsdd": _vm.isFibsdd
    }
  }), _vm._v(" "), _c('nature-choice', {
    attrs: {
      "natures": _vm.fibsdd.natures,
      "gotFluide": _vm.isFluide,
      "isFibsdd": _vm.isFibsdd
    },
    on: {
      "natureUpdated": _vm.updateNature,
      "goToIntervention": function($event) {
        return _vm.navigateTo('intervention')
      }
    }
  })], 1), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeSection === 'intervention'),
      expression: "activeSection === 'intervention'"
    }],
    attrs: {
      "id": "intervention"
    }
  }, [(_vm.isFluide && (_vm.fibsdd.natures.controleNonPeriodique || _vm.fibsdd.natures.controlePeriodique)) ? _c('controle-etanch', {
    attrs: {
      "nofuite": _vm.fibsdd.ctrlEtanch.no_fuites,
      "open": _vm.activeSubsection,
      "detecteur": _vm.detecteur
    },
    on: {
      "openCollapsible": _vm.openSubsection,
      "isValidChanged": _vm.updateValidCtrl
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isFluide) ? _c('manip-fluide', {
    attrs: {
      "open": _vm.activeSubsection,
      "operations": _vm.fibsdd.operations,
      "idFi": _vm.fibsdd.id
    },
    on: {
      "newManip": _vm.updateManipFluide,
      "openCollapsible": _vm.openSubsection
    }
  }) : _vm._e(), _vm._v(" "), _c('infos', {
    attrs: {
      "open": _vm.activeSubsection,
      "informations": _vm.fibsdd.informations
    },
    on: {
      "infosChanged": _vm.updateInfos,
      "openCollapsible": _vm.openSubsection
    }
  }), _vm._v(" "), _c('gestion-pieces', {
    attrs: {
      "open": _vm.activeSubsection,
      "pieces": _vm.fibsdd.pieces
    },
    on: {
      "openCollapsible": _vm.openSubsection,
      "infosChanged": _vm.updateInfos,
      "updatePieces": _vm.piecesChanged
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn-primary mt-5 next",
    attrs: {
      "href": "javascript: void 0"
    },
    on: {
      "click": function($event) {
        return _vm.navigateTo('finish')
      }
    }
  }, [_vm._v("\n                    Finaliser\n                    "), _c('i', {
    staticClass: "icon-go"
  })])], 1), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeSection === 'finish'),
      expression: "activeSection === 'finish'"
    }],
    attrs: {
      "id": "finish"
    }
  }, [_c('div', {
    staticClass: "text-lg font-medium mb-4 uppercase text-secondary"
  }, [_vm._v("\n                    Récapitulatif de l’intervention\n                ")]), _vm._v(" "), _c('small-recap', {
    attrs: {
      "code": _vm.fibsdd.numero,
      "ot": _vm.fibsdd.ordre_travail,
      "detenteur": _vm.detenteur,
      "installation": _vm.installation,
      "gotFluide": _vm.isFluide,
      "isFibsdd": _vm.isFibsdd
    }
  }), _vm._v(" "), _c('recap', {
    attrs: {
      "fibsdd": _vm.fibsdd,
      "fuites": this.fuites
    }
  }), _vm._v(" "), _c('client-infos', {
    attrs: {
      "infosDet": _vm.fibsdd.infosDet
    },
    on: {
      "infosDetUpdated": _vm.updateInfosDet
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn-primary main-action cloturer",
    class: _vm.classClotureWithSignature,
    staticStyle: {
      "margin": "20px 0px"
    },
    attrs: {
      "id": "main-action"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.triggerSignature($event)
      }
    }
  }, [_c('strong', [_vm._v("Signer et Clôturer ")]), _vm._v(" l'intervention\n\n                ")]), _vm._v(" "), _c('a', {
    staticClass: "btn-vert main-action cloturer w-full my-5",
    class: _vm.classClotureWithoutSignature,
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.triggerBypassSignature($event)
      }
    }
  }, [_c('i', {
    staticClass: "icon-error"
  }), _vm._v(" "), _c('strong', [_vm._v("Clôturer détenteur absent")]), _vm._v(" l'intervention\n                ")]), _vm._v(" "), _c('signature-modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showModal),
      expression: "showModal"
    }],
    attrs: {
      "signature": _vm.fibsdd.infosDet.signature_signataire64,
      "clearOnClose": true
    },
    on: {
      "signatureUpdated": _vm.updateSignature,
      "close": function($event) {
        _vm.showModal = false
      }
    }
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-513d685a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fiches/bsdd/Fibsdd.vue
// module id = 1031
// module chunks = 0